const FreeCellTypes = {
  DRAG_CARD: 'DRAG_CARD',
  REMOVE_DRAGGED_CARD: 'REMOVE_DRAGGED_CARD',
  DROP_CARD: 'DROP_CARD',
  DROP_CARD_TO_FREE_CELL: 'DROP_CARD_TO_FREE_CELL',
  DROP_CARD_TO_HOME_CELL: 'DROP_CARD_TO_HOME_CELL',
  START_A_NEW_GAME: 'START_A_NEW_GAME',
  RESTART_THIS_GAME: 'RESTART_THIS_GAME',
  END_GAME: 'END_GAME',
  TOGGLE_MENU: 'TOGGLE_MENU',
  BACK_ONE_STEP: 'BACK_ONE_STEP',
  GET_HINT: 'GET_HINT',
  UPDATE_TIMER: 'UPDATE_TIMER',
  INCREASE_GAME_POINTS: 'INCREASE_GAME_POINTS'
}

export default FreeCellTypes
